import { render, staticRenderFns } from "./tgxxtjChart.vue?vue&type=template&id=7bbcb0ac&scoped=true"
import script from "./tgxxtjChart.vue?vue&type=script&lang=js"
export * from "./tgxxtjChart.vue?vue&type=script&lang=js"
import style0 from "./tgxxtjChart.vue?vue&type=style&index=0&id=7bbcb0ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbcb0ac",
  null
  
)

export default component.exports